document.addEventListener("DOMContentLoaded", function() {
    // Detect Shopify's locale
    const shopLocale = document.documentElement.lang || "en"; // Default to English

    // Only apply translations if the locale is French
    if (shopLocale !== "fr") return;

    // French translations
    const translations = {
        "Select delivery date": "Sélectionnez la date de livraison",
        "Please select date": "Veuillez sélectionner une date",
        "Select time": "Sélectionnez l'heure",
        "No delivery date selected": "Aucune date de livraison sélectionnée",
        "Special instructions for delivery": "Instructions spéciales pour la livraison"
    };

    // Function to translate text and placeholders
    function translateDeliveryText() {
        document.querySelectorAll(".dds-label-text, .flatpickr-input, .dds-comment-box label").forEach(element => {
            const text = element.textContent.trim();
            if (translations[text]) {
                element.textContent = translations[text]; // Translate label text
            } else if (element.placeholder && translations[element.placeholder]) {
                element.placeholder = translations[element.placeholder]; // Translate input placeholder
            }
        });

        // Ensure first-letter capitalization in labels
        document.querySelectorAll(".dds-label-text").forEach(label => {
            label.textContent = label.textContent.charAt(0).toUpperCase() + label.textContent.slice(1).toLowerCase();
        });
    }

    // Run translation on page load
    translateDeliveryText();

    // MutationObserver to catch dynamically loaded elements
    const observer = new MutationObserver(() => {
        clearTimeout(window.translateTimeout);
        window.translateTimeout = setTimeout(translateDeliveryText, 200);
    });

    observer.observe(document.body, { childList: true, subtree: true });

    // Apply translation again when the cart updates
    document.addEventListener("cart:update", translateDeliveryText);

    // Update Flatpickr calendar to French
    function updateFlatpickrLanguage() {
        const flatpickrInput = document.getElementById("dds_calendar");

        if (flatpickrInput && typeof flatpickr !== "undefined" && flatpickrInput._flatpickr) {
            flatpickrInput._flatpickr.set("locale", {
                firstDayOfWeek: 1, // Start week on Monday
                weekdays: {
                    shorthand: ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"],
                    longhand: [
                        "Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"
                    ]
                },
                months: {
                    shorthand: ["Jan", "Fév", "Mar", "Avr", "Mai", "Juin", "Juil", "Août", "Sep", "Oct", "Nov", "Déc"],
                    longhand: [
                        "Janvier", "Février", "Mars", "Avril", "Mai", "Juin",
                        "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"
                    ]
                }
            });

            console.log("Flatpickr language updated to French.");
        }
    }

    // Observe changes to reapply language settings to the calendar
    const flatpickrObserver = new MutationObserver(() => {
        clearTimeout(window.flatpickrTimeout);
        window.flatpickrTimeout = setTimeout(updateFlatpickrLanguage, 500);
    });

    flatpickrObserver.observe(document.body, { childList: true, subtree: true });

    // Ensure the calendar updates shortly after page load
    setTimeout(updateFlatpickrLanguage, 1000);
});
